import { BugsnagApiID, BugsnagApiKey } from '@/envs';

export const HeaderHeight = 88;

// this is the padding we want on top of the anchor when scrolling to element
// 8px seems to render best
export const ScrollTopPadding = 8;

export const CommunitySlackLink = 'https://vonage-community.slack.com';

export const recaptchaSiteKey = '6Ldjr24dAAAAAJwgHuihAL2pJhf-1j4QZUcZVuXP';

export const AssetsPath = '/api/v1/developer/assets';

export const BrandedAssetsPath = `/api/v1/developer/assets/branding/${window.branding.vendorId}`;

// for metadata
export const ApplicationTitle = `${window.branding.vendorName} API Developer`;
export const ApplicationDescription =
  'Get guides and code snippets, browse reference documentation, and more to develop connected applications with Vonage APIs and SDKs.';
export const ApplicationCardImage = {
  Url: `${window.location.protocol}//${window.location.host}${AssetsPath}/meta/nexmo-developer-card.png`,
  Width: '835',
  Height: '437',
};

// https://developer.twitter.com/en/docs/twitter-for-websites/cards/guides/getting-started#started
export const TwitterCardType = 'summary_large_image';

export const SDKDocsRepo = 'https://vonage.github.io/conversation-docs';

export const IsBugsnagEnabled = Boolean(BugsnagApiID) && Boolean(BugsnagApiKey);

export { BugsnagApiID, BugsnagApiKey };

export const FeaturedProductImagesAssetLink = '/assets/images/documentation/featuredProducts/';

/**
 * This variable should be replaced with a proper SSR check if the user is allowed to see the page
 * when we migrate to Nuxt.js.
 */
export const isVonageBrand = window.branding.vendorId === 'vonage';
export const DevPortalURL = 'https://developer.vonage.com';
export const DevPortalURLDeutscheTelekom = 'https://docs.developer.telekom.com';
export const DeutscheTelekomVendorId = 'deutsche-telekom';
export const VonageVendorId = 'vonage';

export const VendorName = window.branding.vendorName ?? '';
export const FallbackPricingLink: Record<string, string> = {
  vonage: 'https://www.vonage.com/communications-apis/pricing',
  'deutsche-telekom': 'https://developer.telekom.com/en/pricing',
  optus: 'https://www.optus.com.au/',
};
